module.exports = __webpack_public_path__ + "static/media/customer-service.3a315af1.svg";